import * as React from "react";
import { connect } from "react-redux";

import {createOrgProfile,fetchStates, fetchDistricts,fetchbanks, fetchOrgProfile} from "./action";
import UpdateProfile from "../../screens/ProfileUpdate/index";

class UpdateProfileContainer extends React.Component<Props, State> {
  render() {
    return <UpdateProfile 
    createOrgProfile = {this.props.createOrgProfile}
    fetchStates={this.props.fetchStates}
    states={this.props.states}
    fetchDistricts={this.props.fetchDistricts}
    districts={this.props.districts}
    fetchbanks={this.props.fetchbanks}
    banks={this.props.banks}
    fetchOrgProfile={this.props.fetchOrgProfile}
    orgProfile={this.props.orgProfile}
    />;
  }
}
function bindAction(dispatch) {
  return {
    createOrgProfile:(val)=> {
      dispatch(createOrgProfile(val));
    },
    fetchStates:()=>{
      dispatch(fetchStates());
    },
    fetchDistricts:(val)=>{
      dispatch(fetchDistricts(val));
    },
    fetchbanks:()=>{
      dispatch(fetchbanks());
    },
    fetchOrgProfile:(val)=>{
      dispatch(fetchOrgProfile(val));
    },
  };
}
const mapStateToProps = (state) => {
  return {
    states:state.UpdateProfileReducer.states,
    districts:state.UpdateProfileReducer.districts,
    banks:state.UpdateProfileReducer.banks,
    orgProfile: state.UpdateProfileReducer.orgProfile,
  };
};

export default connect(mapStateToProps, bindAction)(UpdateProfileContainer);
